import React from 'react';
import { withConfig } from 'hoc/config.hoc.js';
import AdvertiserToolTipView from 'advertiserTooltip_brand/AdvertiserToolTipView';

const Disclaimer = ({
  datatestid,
  pagePosition,
  className,
  vertical,
  disclaimerText = '',
  disclosure,
  ...props
}) => {
  const { config, pageName } = props;
  let finalConfig = config;
  let disclaimer =
    disclaimerText ||
    (finalConfig && config.disclaimers?.advertiserDisclosureCopy) ||
    '';

  const partnerText = props.showPartnerText ? props.partnerText : '';
  return (
    <AdvertiserToolTipView
      datatestid={datatestid}
      className={className}
      partnerText={partnerText}
      vertical={vertical}
      pageName={pageName}
      disclaimer={disclaimer}
      pagePosition={pagePosition}
      disclosure={disclosure ? disclosure : 'Advertiser Disclosure'}
    />
  );
};

const connectedDisclaimer = withConfig(Disclaimer);

export { connectedDisclaimer as Disclaimer };
